function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.6 7.15263C9.432 7.38158 9.312 7.63421 9.2 7.89474H4.8V6.71053C4.8 6.48947 4.976 6.31579 5.2 6.31579H9.2C9.424 6.31579 9.6 6.48947 9.6 6.71053V7.15263ZM14.4 4.73684H0V0H14.4V4.73684ZM12.8 1.57895H1.6V3.15789H12.8V1.57895ZM8 12.6316H2.4V5.52632H0.8V14.2105H8.024C8 14.1316 8 14.0526 8 13.9737V12.6316ZM16 11.2895V14.0526C16 14.5263 15.52 15 14.96 15H10.56C10.08 15 9.6 14.5263 9.6 13.9737V11.2105C9.6 10.7368 10.08 10.2632 10.56 10.2632V9.07895C10.56 7.97368 11.68 7.10526 12.8 7.10526C13.92 7.10526 15.04 7.97368 15.04 9.07895V10.2632C15.52 10.2632 16 10.7368 16 11.2895ZM14 9.07895C14 8.44737 13.44 8.05263 12.8 8.05263C12.16 8.05263 11.6 8.44737 11.6 9.07895V10.2632H14V9.07895Z",
  fill: "currentColor"
});

function SvgAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.4363b85c.svg";
export { ForwardRef as ReactComponent };